import { render, staticRenderFns } from "./Monitriip.vue?vue&type=template&id=0134f024&"
import script from "./Monitriip.vue?vue&type=script&lang=js&"
export * from "./Monitriip.vue?vue&type=script&lang=js&"
import style0 from "./Monitriip.vue?vue&type=style&index=0&id=0134f024&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports